"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var constants = _interopRequireWildcard(require("@paprika/constants/lib/Constants"));

DateInputPropsCollector.propTypes = propTypes; // eslint-disable-line no-use-before-define

DateInputPropsCollector.defaultProps = defaultProps; // eslint-disable-line no-use-before-define
// eslint-disable-next-line no-use-before-define

DateInputPropsCollector.types = {
  size: constants.defaultSize
};
var propTypes = {
  /** a11yText on the input. */
  a11yText: _propTypes["default"].string,

  /** Custom clear icon */
  clearIcon: _propTypes["default"].node,

  /** Placeholder of input. */
  placeholder: _propTypes["default"].string,

  /** Size of input. */
  size: _propTypes["default"].oneOf([DateInputPropsCollector.types.size.SMALL, // eslint-disable-line no-use-before-define
  DateInputPropsCollector.types.size.MEDIUM, // eslint-disable-line no-use-before-define
  DateInputPropsCollector.types.size.LARGE // eslint-disable-line no-use-before-define
  ]),

  /** If the value of <input> is valid or not. */
  hasError: _propTypes["default"].bool
};
var defaultProps = {
  a11yText: null,
  clearIcon: null,
  placeholder: "",
  size: DateInputPropsCollector.types.size.MEDIUM,
  // eslint-disable-line no-use-before-define
  hasError: false
}; // shell component for enhancing development experience

function DateInputPropsCollector() {
  return null;
}

DateInputPropsCollector.displayName = "DatePicker.Input";
var _default = DateInputPropsCollector;
exports["default"] = _default;
//# sourceMappingURL=DateInputPropsCollector.js.map